import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: 'Do I need a specialty Mexican market?',
  a: 'No. Every recipe is designed using ingredients available at major U.S. chains.'
}, {
  q: 'Is the food too spicy?',
  a: 'You control the heat. We show you how to get the flavor of the chiles without the burn.'
}, {
  q: 'Is it a physical book?',
  a: 'It is a high-resolution Digital PDF. You get it instantly after purchase.'
}, {
  q: 'What devices can I open the PDF on?',
  a: 'Any device! You can open it on your phone, tablet, computer, or Kindle.'
}, {
  q: 'Can I print the recipes?',
  a: 'Yes, the PDF includes print-friendly formatting so you can easily print your favorite recipes.'
}, {
  q: 'How long do the recipes take?',
  a: 'Most recipes take under 45 minutes. The slow cooker recipes do the work while you sleep or work.'
}, {
  q: 'Are there gluten-free / dairy-free options?',
  a: 'Yes, every recipe includes substitution notes for gluten-free and dairy-free diets.'
}, {
  q: "What if I don't like it?",
  a: 'We offer a 30-day money-back guarantee. No questions asked.'
}, {
  q: 'Is there a Spanish version?',
  a: 'Currently, the book is in English only, but all original Mexican recipe names are preserved.'
}, {
  q: 'How quickly do I get access?',
  a: 'Instantly after purchase! The download link is delivered straight to your email.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-215">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-216">
        <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-12 text-center" data-id="element-217">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4" data-id="element-218">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-[#3E2723]/10 overflow-hidden" data-id="element-219">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-[#C2410C] focus:ring-inset" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} aria-expanded={openIdx === idx} data-id="element-220">
                <span className="text-lg font-semibold text-[#3E2723] pr-4" data-id="element-221">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-[#C2410C] flex-shrink-0" data-id="element-222" /> : <ChevronDown className="w-5 h-5 text-[#C2410C] flex-shrink-0" data-id="element-223" />}
              </button>
              {openIdx === idx && <div className="px-6 pb-5 text-[#3E2723]/70 leading-relaxed" data-id="element-224">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}